export default __webpack_public_path__ + "assets/models/216bb19c17e14ec595298d2d1c5fd5a3.glb";